<template>
  <div>
    <div class="main container">
      <div class="title-box">
        <span class="title">{{ title }}</span> >> 相关素材
      </div>
      <div class="meta">
        <div>
          共筛选出{{ materialCount }}张素材
          <span v-if="!!updateTime">更新时间：{{ updateTime }}</span>
        </div>
      </div>
      <div class="list">
        <MaterialItem
          v-for="item in materialArr"
          :material="item"
          :key="item.id"
        ></MaterialItem>
      </div>
    </div>
    <div class="pager">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="curPage"
        :page-size="100"
        layout="prev, pager, next, jumper"
        :total="1000"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import MaterialItem from "../components/MaterialItem";
export default {
  name: "AdIdeasDetail",
  components: { MaterialItem: MaterialItem },
  mounted() {
    this.id = this.$route.query["id"];
    this.queryAdIdeas();
  },
  data() {
    return {
      id: "",
      title: "",
      curPage: 1,
      materialCount: 0,
      updateTime: "",
      materialArr: [],
    };
  },
  methods: {
    queryAdIdeas() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      let option = {
        id: this.id,
        page: this.curPage,
        num: 9,
      };
      this.$http
        .get(
          "/fireeye/copywriting/material/list?id=" +
            this.id +
            "&page=" +
            this.curPage +
            "&num=9",
          { params: option }
        )
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            this.materialArr = data.data.list;
            this.materialCount = data.data.total;
            this.title = data.data.title;
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    handleSizeChange() {},
    handleCurrentChange() {
      this.queryAdIdeas();
    },
  },
};
</script>
<style lang="less" scoped>
.filter {
  padding: 25px 15px;
  box-shadow: 0 0 5px #ddd;
  border-radius: 6px;
  font-size: 12px;

  .search-box {
  }
  .search-btn {
  }
  .row {
    height: 60px;
    line-height: 60px;
    overflow: hidden;

    .col {
      text-align: left;
    }
  }
}
.main {
  .title-box {
    font-size: 14px;

    .title {
      color: #409eff;
    }
  }

  .meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    height: 60px;
    line-height: 60px;

    .sort {
      label {
        padding-right: 20px;
      }
      .el-select {
        display: inline-block;
      }
    }
  }

  .list {
    margin-right: -15px;
    display: flex;
    flex-wrap: wrap;
  }
}
.pager {
  margin: 30px 0 60px;
}
</style>